import { useLazyGetLoanApplicationConditionsByIdQuery } from "@api/applications";
import { formatCurrency } from "@helpers/funciones";
import useInterfaceConfig from "@hooks/useInterfaceConfig";
import { Typography, Divider, useTheme, useMediaQuery, Box, Skeleton } from "@mui/material";
import { RootState } from "@store/store";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Sentry from "@sentry/react";

export const LoanConditions = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const applicationData = useSelector((state: RootState) => state.register.application);
  const interfaceConfig = useInterfaceConfig();

  const [getApplicationConditions] = useLazyGetLoanApplicationConditionsByIdQuery();

  const [isLoading, setIsLoading] = useState(true);
  const [loanAmount, setLoanAmount] = useState(0);
  const [loanTerm, setLoanTerm] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const response = await getApplicationConditions(applicationData.id).unwrap();
        if (response) {
          setLoanAmount(response.selected_amount || 0);
          setLoanTerm(response.selected_term || 0);
        }
      } catch (error) {
        Sentry.captureException(error, {
          extra: {
            component: "LoanConditions",
            values: {
              applicationId: applicationData.id,
            },
          },
        });
      } finally {
        setIsLoading(false);
      }
    })();
  }, [applicationData, getApplicationConditions]);

  return (
    <Box display={"flex"} flexDirection={"row"} mt={4}>
      <Box width={"45%"}>
        <Typography variant={isMobileOrTablet ? "body2" : "body1"} fontWeight={400} textAlign={"center"}>
          Monto del crédito
        </Typography>
        {isLoading ? (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Skeleton variant="text" width={200} height={40} />
          </Box>
        ) : (
          <Typography variant={isMobileOrTablet ? "body2" : "body1"} fontWeight={500} textAlign={"center"}>
            {formatCurrency(loanAmount)}{" "}
            <Typography variant="body3" fontWeight={500}>
              {interfaceConfig.cotizador?.current_currency || "MXN"}
            </Typography>
          </Typography>
        )}
      </Box>

      <Box width={"10%"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
        <Divider orientation="vertical" flexItem sx={{ mr: "-2px", border: "1px solid #F2704F" }} />
      </Box>

      <Box width={"45%"}>
        <Typography variant={isMobileOrTablet ? "body2" : "body1"} fontWeight={400} textAlign={"center"}>
          Plazo
        </Typography>
        {isLoading ? (
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <Skeleton variant="text" width={200} height={40} />
          </Box>
        ) : (
          <Typography variant={isMobileOrTablet ? "body2" : "body1"} fontWeight={500} textAlign={"center"}>
            {loanTerm} {interfaceConfig.cotizador?.term_type || "meses"}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
